import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CheckCircle, XCircle, HelpCircle } from "lucide-react";
import http from "@/lib/api";
import { toast } from "sonner";

export default function Godkjenning() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    http.get(`/v1/public/approval/${token}`).then((r) => setData(r.data)).catch(() => setError("Godkjenningsforespørsel ikke funnet.")).finally(() => setLoading(false));
  }, [token]);

  const respond = async (response_type) => {
    try {
      await http.post(`/v1/public/approval/${token}`, { response_type, comment });
      setDone(true);
      toast.success("Takk for tilbakemeldingen!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Noe gikk galt.");
    }
  };

  const alreadyAnswered = data && data.response_type && data.response_type !== "pending";

  return (
    <Layout>
      <section className="py-16 md:py-24 bg-[#FFF8F0] min-h-[60vh]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-[#D4A574]/30 shadow-lg">
            <CardHeader><CardTitle className="text-xl text-[#3D2314] font-display">Prisgodkjenning</CardTitle></CardHeader>
            <CardContent>
              {loading && <p className="text-[#1A1A1A]/60">Laster...</p>}
              {error && <p className="text-red-600">{error}</p>}
              {done && <div className="text-center py-6"><CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-4" /><p className="text-[#3D2314] font-medium">Din tilbakemelding er registrert. Takk!</p></div>}
              {!loading && !error && !done && data && (
                <div className="space-y-6">
                  {data.job_code && <p className="text-sm text-[#1A1A1A]/70">Saksreferanse: <strong className="text-[#3D2314]">{data.job_code}</strong></p>}
                  {data.customer_confirmation_text && <div className="bg-[#FFF8F0] rounded-lg p-4 text-sm text-[#1A1A1A]/80 whitespace-pre-wrap">{data.customer_confirmation_text}</div>}
                  {data.estimated_cost && <p className="text-lg font-bold text-[#3D2314]">Estimert pris: {data.estimated_cost}</p>}
                  {alreadyAnswered ? (
                    <p className="text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm">Denne forespørselen er allerede besvart ({data.response_type}).</p>
                  ) : (
                    <>
                      <div><label className="text-sm font-medium text-[#3D2314]">Kommentar (valgfritt)</label><Textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={3} className="mt-1 border-[#D4A574]/30" /></div>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <Button onClick={() => respond("approved")} className="flex-1 bg-green-600 hover:bg-green-700 text-white gap-2"><CheckCircle className="h-4 w-4" />Godkjenn</Button>
                        <Button onClick={() => respond("declined")} variant="outline" className="flex-1 border-red-300 text-red-700 hover:bg-red-50 gap-2"><XCircle className="h-4 w-4" />Avslå</Button>
                        <Button onClick={() => respond("more_info")} variant="outline" className="flex-1 gap-2"><HelpCircle className="h-4 w-4" />Mer info</Button>
                      </div>
                    </>
                  )}
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>
  );
}
